import React from 'react';
import NoteViewer from '../components/TopLeftNoteViewer';
import UserInfo from '../components/TopRightUserInfo';
import NoteTaker from '../components/BottomLeftNoteTaker';
import TextViewer from '../components/BottomRightTextViewer';
import '../css/LoggedIn.css'; // Import the CSS file

function LoggedIn({ authenticated, authConfig }) {
  return (
    <div className="logged-in-container">
      <div className="left-column">
        <NoteViewer authenticated={authenticated} />
        <UserInfo authenticated={authenticated} authConfig={authConfig} />
      </div>
      <div className="right-column">
        <NoteTaker />
        <TextViewer />
      </div>
    </div>
  );
}

export default LoggedIn;
